<div class="main-container">
  <div class="container-fluid">
    <div class="row">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="col-12">
        <div class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3">Loading driver information...</p>
        </div>
      </div>

      <!-- Main Content -->
      <div *ngIf="!isLoading && orderTrack.task" class="col-12">
        <!-- Company Logo -->


        <!-- Driver Review Section -->
        <div class="review-container">
          <div class="row justify-content-center">
            <!-- Driver Information Card -->
            <div class="col-lg-3 col-md-6">
              <div class="driver-card">
                <!-- Review Input Section - Google Style -->
                <div class="review-section-inline google-review-style" *ngIf="!reviewSubmitted">
                  <!-- <div class="review-divider"></div> -->

                  <!-- Title -->
                  <div class="review-header-with-logo">
                    <h2 class="review-main-title">Write a Review</h2>
                    <div class="logo-container-review" *ngIf="companyURL">
                      <img src="/images/mobile2000.png" alt="Company Logo" />
                    </div>
                  </div>

                  <!-- Task IDs -->
                  <div class="task-ids-review">
                    <span class="task-id-review" *ngIf="orderTrack?.task?.shortId">
                      Task ID: {{ orderTrack.task.shortId }}
                    </span>
                    <span class="task-id-separator"
                      *ngIf="orderTrack?.task?.shortId && orderTrack?.task?.alternativeId"> • </span>
                    <span class="task-id-review" *ngIf="orderTrack?.task?.alternativeId">
                      Custom ID: {{ orderTrack.task.alternativeId }}
                    </span>
                  </div>

                  <!-- Reviewer Info -->
                  <div class="reviewer-info">
                    <div class="reviewer-avatar">
                      <span class="avatar-initial">{{ getReviewerInitial() }}</span>
                    </div>
                    <div class="reviewer-details">
                      <div class="reviewer-name">{{ getReviewerName() }}</div>
                      <div class="review-privacy-notice">
                        All feedback is treated as confidential and is used solely to help our operations team improve
                        service quality.
                      </div>
                    </div>
                  </div>

                  <!-- Star Rating -->
                  <div class="rating-section-google">
                    <div class="star-rating-google" (touchstart)="onTouchStart($event)"
                      (touchmove)="onTouchMove($event)" (touchend)="onTouchEnd($event)">
                      <span *ngFor="let star of [1,2,3,4,5]; let i = index" class="star-google"
                        [class.active]="(hoveredRating || rating) >= star" (click)="setRating(star)"
                        (mouseenter)="setHoveredRating(star)" (mouseleave)="clearHoveredRating()">
                        <i class="bi" [class.bi-star-fill]="(hoveredRating || rating) >= star"
                          [class.bi-star]="(hoveredRating || rating) < star"></i>
                      </span>
                    </div>
                  </div>

                  <!-- Review Comment -->
                  <div class="comment-section-google">
                    <textarea id="reviewCommentGoogle" class="form-control-google" rows="8" placeholder=""
                      [(ngModel)]="reviewComment">
                    </textarea>
                  </div>

                  <!-- Footer with buttons -->
                  <div class="review-footer">
                    <div class="reviews-powered-by">
                      Powered by <a style="color: #2050e0;" href="https://www.wiyak.com/wifleet">Wifleet</a>. Made with
                      love in Kuwait 🇰🇼
                    </div>
                    <div class="review-buttons">
                      <button class="btn-cancel" (click)="cancelReview()">
                        CLEAR
                      </button>
                      <button class="btn-post" (click)="submitReview()" [disabled]="rating === 0 || isSubmitting">
                        <span *ngIf="!isSubmitting">SUBMIT</span>
                        <span *ngIf="isSubmitting">Submitting...</span>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Thank You Message within Driver Card -->
                <div class="review-section-inline"
                  *ngIf="!showReviewForm && (orderTrack?.orderStatus?.task_status == 9 || orderTrack?.orderStatus?.task_status == 15)">
                  <div class="review-divider"></div>
                  <div class="thank-you-inline">
                    <div class="thank-you-icon-inline">
                      <i class="bi bi-check-circle-fill"></i>
                    </div>
                    <h5>We Value Your Feedback</h5>
                    <p>Thank you for sharing your feedback. All responses are kept confidential and used to enhance
                      service quality.</p>
                    <p>To learn more about our product, please <a style="color: #2050e0;"
                        href="https://www.mobile2000.com/"> visit our website.
                      </a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && !orderTrack.task" class="col-12">
        <div class="error-container">
          <i class="bi bi-exclamation-triangle"></i>
          <h3>Task Not Found</h3>
          <p>Unable to load task information. Please check the task ID and try again.</p>
        </div>
      </div>
    </div>
  </div>
</div>